<div class="container-fluid">
  <ng-http-loader></ng-http-loader>
  <router-outlet (keydown)="disabledTab($event)"></router-outlet>
</div>